export class EditApplicationSettingDetailInput {
    public id: number = 0;
    public value: string = '';
}
